import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Navigation bar */}
      <Navbar />

      <div className="container">
        <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center', padding: '40px 20px' }}>
          <div style={{ fontSize: '60px', marginBottom: '20px' }}>🚫</div>
          <h1 style={{ marginBottom: '15px', color: '#ffc107' }}>Paiement annulé</h1>
          <p style={{ color: '#666', marginBottom: '30px' }}>
            Vous avez annulé le processus de paiement. Aucun montant n'a été débité.
          </p>
          <p style={{ color: '#666', marginBottom: '30px' }}>
            Vous pouvez réessayer à tout moment depuis votre dashboard.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/dashboard')}
          >
            Retour au dashboard
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentCancel;

